import ToastService from "./toast.service";
import { Chain } from "./store.service";

interface HelperService {
  shortenAddress: (address: string) => string;
  chainFromId: (id: number) => Chain;
  copyAddressToClipboard: (value: string) => any;
}

const HelperService: HelperService = {
  shortenAddress: (address: string) => {
    return (
      address.substring(0, 6) + "..." + address.substring(address.length - 4)
    );
  },

  chainFromId: (id: number) => {
    switch (id) {
      case 14:
        return Chain.FLR;
      case 19:
        return Chain.SGB;
      case 16:
        return Chain.COSTON;
      case 114:
        return Chain.COSTON2;
      default:
        throw new Error(`Invalid chain id ${id}`);
    }
  },

  copyAddressToClipboard: (value: string) => {
    navigator.clipboard.writeText(value);
    ToastService.info("Address copied to clipboard", "", {
      autoClose: 2000,
    });
  },
};
export default HelperService;
